export class HeroBg extends DrupalBehavior {
  onReady() {
    const breakpoint = window.matchMedia('(min-width: 768px)');

    breakpoint.addEventListener('change', this.build());
    addEventListener('resize', (event) => {
      this.build();
    });

    this.setUpVideoButtonListeners();
  }

  // Centered full screen width video header.
  build() {
    let $videoContainer = document.getElementsByClassName('hero__bg-video')[0];
    if ($videoContainer) {
      let marginTop = 0;
      let $videoIframe = $videoContainer.getElementsByTagName('iframe');
      if ($videoIframe && $videoIframe.length) {
        let $hero = document.getElementsByClassName('hero__bg')[0];

        marginTop -= $videoIframe[0].offsetHeight / 2 - $hero.offsetHeight / 2;
        $videoIframe[0].style.top = marginTop + 'px';
      }
    }
  }

  // Initialize video play/pause buttons
  setUpVideoButtonListeners() {
    const videoContainer = document.querySelector('.hero__bg-video');
    if (videoContainer) {
      const controlButtons = videoContainer.querySelectorAll(
        '.hero__bg-video--video-control'
      );
      const iframe = videoContainer.querySelector('iframe');
      const pauseBtn = videoContainer.querySelector('.pause-video');
      const playBtn = videoContainer.querySelector('.play-video');

      if (controlButtons.length > 0 && iframe) {
        controlButtons.forEach((button) => {
          button.addEventListener('click', function (e) {
            e.preventDefault();

            const url = button.getAttribute('data-video-url');
            const targetOrigin = new URL(url).origin;
            const isYouTube =
              url.includes('youtube.com') || url.includes('youtu.be');
            const isVimeo = url.includes('vimeo.com');

            if (button.classList.contains('pause-video')) {
              // Pause the video
              if (isYouTube) {
                iframe.contentWindow.postMessage(
                  JSON.stringify({
                    event: 'command',
                    func: 'pauseVideo',
                    args: [],
                  }),
                  targetOrigin
                );
              } else if (isVimeo) {
                iframe.contentWindow.postMessage(
                  JSON.stringify({ method: 'pause' }),
                  targetOrigin
                );
              }

              pauseBtn.classList.add('hidden');
              playBtn.classList.remove('hidden');
            } else if (button.classList.contains('play-video')) {
              // Resume the video
              if (isYouTube) {
                iframe.contentWindow.postMessage(
                  JSON.stringify({
                    event: 'command',
                    func: 'playVideo',
                    args: [],
                  }),
                  targetOrigin
                );
              } else if (isVimeo) {
                iframe.contentWindow.postMessage(
                  JSON.stringify({ method: 'play' }),
                  targetOrigin
                );
              }

              playBtn.classList.add('hidden');
              pauseBtn.classList.remove('hidden');
            }
          });
        });
      }
    }
  }
}

DrupalBehavior.register('rush_theme.components', 'hero_bg', HeroBg);
